'use client';

import {
  useCallback, useRef, useState, useEffect,
} from 'react';
import moment from 'moment-timezone';

interface OnSiteQuoteApprovalTimerProps {
  quoteExpiryAt: string;
  onFinish?: () => void;
  className?: string;
}

const OnSiteQuoteApprovalTimer = ({
  quoteExpiryAt,
  onFinish,
  className = '',
}: OnSiteQuoteApprovalTimerProps) => {
  const expiryTimeInUtc = moment.utc(quoteExpiryAt, 'YYYY-MM-DD HH:mm:ss');

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [timeLeft, setTimeLeft] = useState(0);
  
  const updateTimeLeft = useCallback(() => {
    const requestedTimeDifSeconds = expiryTimeInUtc.diff(moment.utc(), 'seconds');
    if (requestedTimeDifSeconds <= 0) {
      if (timeoutRef.current) {
        setTimeLeft(0);
        clearTimeout(timeoutRef.current);
        onFinish?.();
      }
      return;
    }

    setTimeLeft(requestedTimeDifSeconds);
    timeoutRef.current = setTimeout(() => {
      updateTimeLeft();
    }, 1000);
  }, [expiryTimeInUtc, onFinish]);

  useEffect(() => {
    updateTimeLeft();
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [updateTimeLeft]);
  
  if (!expiryTimeInUtc.isValid()) return '';
  
  return (
    <b className={`d-block ${className}`}>
      {moment.duration(timeLeft, 's').minutes()}
      :
      {moment.duration(timeLeft, 's').seconds()}
      {' '}
      left
    </b>
  );
};

export default OnSiteQuoteApprovalTimer;
